// src/components/Hero.js
import React from "react";
import hero from "../assets/img/video/video-2.mp4";
import bgImage from "../assets/img/cart/IMG_0091.PNG";

const Hero = () => {
  return (
    <section id="hero" className="hero section dark-background">
      <div className="video-background">
        <img
          src={bgImage}
          alt="homeBG"
          className="w-full h-full"
          style={{
            objectFit: "cover",
          }}
        />
        {/* <video autoPlay muted loop playsInline>
          <source src={hero} type="video/mp4" />
          Your browser does not support the video tag.
        </video> */}
        <div className="video-overlay"></div>
      </div>

      <div className="hero-content">
        <div className="container position-relative">
          <div className="row justify-content-center text-center">
            <div className="col-lg-8">
              <h1
                data-aos="fade-up"
                data-aos-delay="100"
                className="font-style-cart-studio"
                style={{
                  fontSize: "100px",
                }}
              >
                CART STUDIO
              </h1>
              <h2
                data-aos="fade-up"
                data-aos-delay="150"
                className="text-xl text-orange-600 capitalize font-style-cart-studio"
              >
                Custom Tricycle & E-Cart Manufacturers
              </h2>
              <div
                style={{
                  marginTop: "25px",
                }}
                className="hero-buttons font-style-cart-studio"
                data-aos="fade-up"
                data-aos-delay="300"
              >
                <a href="/product" className="btn btn-primary">
                  PRODUCT
                </a>
                {/* <a href="#services" className="btn btn-outline">
                  Learn More
                </a> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
